import $ from '../tools/Dom';
import request from '../tools/request';

export default el => {
    const dom = $(el);
    const container = dom.find('[data-container]');
    const moreButton = dom.find('[data-more]').find('a');

    const onLoadMore = e => {
        e.preventDefault();

        const node = e.triggerTarget;

        request.get(node.href).then(res => {
            const text = $(res.text);
            const oldHeight = container.height();
            let buttonHeight = 0;

            if (text.data('next')) {
                moreButton.attr('href', text.data('next'));
            } else {
                buttonHeight = moreButton.parent().height();

                // TweenMax.to(moreButton.get(0), 0.5, { autoAlpha: 0 });
                // TweenMax.to(container.get(0), 2.5, { height: oldHeight - 128})
                TweenMax.to(moreButton.parent().get(0), 0.5, { height: 0, opacity: 0, ease: Quad.easeInOut, onComplete: () => {
                    moreButton.parent().remove();
                } });
            }

            TweenMax.set(container.get(0), { overflow: 'hidden', height: 'auto' });
            container.append(text.html());
            const newHeight = container.height() - buttonHeight;
            TweenMax.set(container.get(0), { overflow: 'hidden', height: oldHeight });
            TweenMax.to(container.get(0), 0.5, { height: newHeight, ease: Quad.easeInOut, clearProps: 'all' });
        }, error => {
            console.error(error);
        });
    };

    const init = () => {
        moreButton.on('click', onLoadMore);
    };

    const destroy = () => {
        moreButton.off('click');
    };

    return {
        init,
        destroy
    };
};
